import {
  RESET_PORTAL_CONTEXT,
  TURNO_SALDADO_LOADING,
  TURNO_SALDADO_SUCCESS,
  TURNO_SALDADO_ERROR,
} from "../ActionTypes";
import turnoSaldadoInitialState from "../initialStates/turnoSaldadoInitialState";

const turnoSaldado = (state, { payload, type }) => {
  switch (type) {
    case TURNO_SALDADO_LOADING:
      return {
        ...state,
        turnoSaldado: {
          ...state.turnoSaldado,
          error: false,
          loading: true,
        },
      };
    case TURNO_SALDADO_SUCCESS:
      return {
        ...state,
        turnoSaldado: {
          ...state.turnoSaldado,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case TURNO_SALDADO_ERROR:
      return {
        ...state,
        turnoSaldado: {
          ...state.turnoSaldado,
          error: payload,
          loading: false,
        },
      };
    case RESET_PORTAL_CONTEXT:
      return turnoSaldadoInitialState;
    default:
      return state;
  }
};

export default turnoSaldado;
